import React from 'react';
import ProviderGroupDetail from 'components/Tvendo/Commissions/DataMaster/ProviderGroup/ProviderGroupDetail/ProviderGroupDetail';

export default function () {
  return <ProviderGroupDetail />;
}
